import { render, staticRenderFns } from "./HeavyComp.vue?vue&type=template&id=634df123&scoped=true"
import script from "./HeavyComp.vue?vue&type=script&lang=js"
export * from "./HeavyComp.vue?vue&type=script&lang=js"
import style0 from "./HeavyComp.vue?vue&type=style&index=0&id=634df123&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634df123",
  null
  
)

export default component.exports